export default __webpack_public_path__ + "static/media/timer_s3.b4962ac9.png";